<template>
    <div class="overlay" v-if="connectionOverlayShown">
        <br/>
        <header-message class="mt-5 mb-5">
            The server connection has been lost.
        </header-message>
        <br/>
        <header-message class="mt-3 mb-5">
            <fa-icon icon="spinner" class="fa-spin" /> Attempting to reconnect...
        </header-message>
        <br/>
        <div v-if="showRestart" class="buttondiv mt-2">
            <button-button class="btn btn-danger" @click.prevent="restartClicked">Restart Session</button-button>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    .overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.80);
        color: white;
        z-index: 3000; // Ensure it overlays any other content
    }
    .buttondiv {
        text-align:center;
    }
</style>

<script lang="ts">
import { defineComponent } from "vue";
import HeaderMessage from "./HeaderMessage.vue";
import OverlaySuppression from "@/shared/support/OverlaySuppression";
import { Global } from "@/support/GlobalData";

export default defineComponent({
    data(): any {
        return {
            showRestart: false,
            showRestartTimeout: 0,
            showRestartSeconds: 10,
            connectionOverlayShown: false
        };
    },
    components: {
        HeaderMessage
    },
    methods: {
        show(): void {
            if (this.connectionOverlayShown) return;
            this.connectionOverlayShown = true;
            OverlaySuppression.acquire(this);
            if (!this.showRestartTimeout) {
                this.showRestartTimeout = window.setTimeout((): void => {
                    this.showRestart = true;
                }, this.showRestartSeconds * 1000);
            }
        },
        hide(): void {
            this.connectionOverlayShown = false;
            OverlaySuppression.release(this);
            this.showRestart = false;
            clearTimeout(this.showRestartTimeout);
            this.showRestartTimeout = 0;
        },
        restartClicked(): void {
            Global.MainApp.restartSession("The session will be restarted.");
        }
    }
});

</script>